"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultContactState = void 0;
exports.defaultContactState = {
    heading: 'Tight on time? Let us do the searching for you!',
    nameSubmit: 'Submit',
    nameYourName: 'Your Name',
    nameYourEmail: 'Your Email',
    nameContactUs: 'Contact Us',
    headingContactUs: 'Contact Us',
    contactAgentButton: 'Contact an OKAY.COM agent',
    isDomLoaded: false,
};
